module.exports = __webpack_public_path__ + "img/tech-practice.5a8c3df3.svg";